import { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import responsiveStyles from './responsiveStyles.module.scss'

interface viewChartDataInterface {
    chartData: any
    closeModal: any
    chartTitle: string
    chartDate: string
}

export const ViewChartDataModalContent = (props: viewChartDataInterface) => {
    const { chartData, closeModal, chartTitle, chartDate } = props
    const [data, setData] = useState<any>([])
    const [title, setTitle] = useState('')
    const [date, setDate] = useState('')
    const [tableHeaders, setTableHeaders] = useState<string[]>([])

    useEffect(() => {
        if (chartData) {
            setData(chartData)
        }
    }, [chartData])

    useEffect(() => {
        if (data && data.length > 0) {
            setTableHeaders(Object.keys(data[0]))
        }
    }, [data])

    useEffect(() => {
        if (chartTitle) setTitle(chartTitle)
    }, [chartTitle])

    useEffect(() => {
        if (chartDate) setDate(chartDate)
    }, [chartDate])

    return (
        <div className={styles.chartDataView}>
            <div className={styles.titleContainer}>
                <h3>
                    <span>{title}</span>
                </h3>
                <p>{date}</p>
            </div>
            <div className={styles.dataResults}>
                {tableHeaders && (
                    <table>
                        <thead>
                            <tr>
                                {tableHeaders.map((x, i) => (
                                    <th key={i}>{x.replaceAll('_', ' ')}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((x: any, i: number) => (
                                <tr key={i}>
                                    {Object.values(x).map((value: any, j: number) => (
                                        <td key={j}>{value}</td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    )
}
